import { KBFolderListPage } from '@/modules/gpt-chats/components/knowledge-base/kb-folder-list';

export const KnowledgeBase = () => {
  return <KBFolderListPage />;
};
